import { ProIcon } from './ProIcon';

export const ProBadge = () => (
  <ProIcon width={40} height={25} />
);
